import classNames from '@utils/cx';
import { MouseEventHandler, ReactNode } from 'react';
import { NavLink } from 'react-router';

type NavbarItemProps = {
    to?: string;
    children: ReactNode;
    onClick?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
    asChildren?: boolean;
};

const NavbarItem = ({ to, children, onClick, asChildren }: NavbarItemProps) => {
    const sharedClassName = 'navbar__link';

    const renderItem = () => {
        if (asChildren) {
            return children;
        }

        // Action item (e.g. logout): no route, just an onClick.
        if (!to) {
            return (
                <button
                    type="button"
                    onClick={onClick}
                    className={sharedClassName}
                >
                    {children}
                </button>
            );
        }

        return (
            <NavLink
                to={to}
                onClick={onClick}
                className={({ isActive }) =>
                    classNames(sharedClassName, {
                        'is-active': isActive,
                    })
                }
            >
                {children}
            </NavLink>
        );
    };

    return <li className="navbar__item">{renderItem()}</li>;
};

export default NavbarItem;
